import http from "@/axios";
import {ConsumableInfo, ConsumableSetting, ConsumableWithCount} from "@/store/consumable/types";
import {Player} from "@/store/player/types";
import PlayerStore from "@/store/player";

export default class ConsumableStore {

    public static consumablePlaceInfo(placeId: number): Promise<ConsumableInfo> {
        return http.get('/api/consumable/consumablePlaceInfo?placeId=' + String(placeId))
            .then(r => r.data)
            .then(consumableInfo => {
                let ci: ConsumableInfo = Object.assign(new ConsumableInfo(), consumableInfo);
                return ci;
            });
    }

    public static takeConsumable(placeId: number): Promise<Player> {
        var params = new URLSearchParams();
        params.append('placeId', String(placeId));

        return http.post('/api/consumable/takeConsumableFromRoad', params)
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    }

    public static fetchSlotsSettings(): Promise<ConsumableSetting[]> {
        return http.get('/api/consumable/slot/settings/get')
            .then(r => r.data)
            .then(pObj => {
                let res: ConsumableSetting[] = [];
                for (let obj of pObj) {
                    let sc = Object.assign(new ConsumableSetting(), obj);
                    res.push(sc);
                }
                return res;
            });
    }

   public static getBackpackItems(limit:number): Promise<ConsumableWithCount[]> {
        return http.get('/api/consumable/backpack/get?limit=' + String(limit))
            .then(r => r.data)
            .then(pObj => {
                let res: ConsumableWithCount[] = [];
                for (let obj of pObj) {
                    let sc = Object.assign(new ConsumableWithCount(), obj);
                    res.push(sc);
                }
                return res;
            });
    }

    public static setupSlotsSettings(cs: ConsumableSetting[]): Promise<void> {
        return http.post('/api/consumable/slot/settings/set', cs);
    }
}
